import ReactDOM from 'react-dom'

import Spinner from './Spinner'
import {
  LoaderOverlayProps,
  StyledLoaderOverlay,
  StyledCompanyImage,
} from './styles'

function LoaderOverlay({
  isFullScreen,
  isSemiTransparent,
}: LoaderOverlayProps) {
  if (isFullScreen) {
    const container = document.querySelector('#root')
    if (!container) return null

    return ReactDOM.createPortal(
      <StyledLoaderOverlay isFullScreen={isFullScreen}>
        <StyledCompanyImage src="/images/s-logo.svg" alt="Savant logo" />
      </StyledLoaderOverlay>,
      container
    )
  }

  return (
    <StyledLoaderOverlay isSemiTransparent={isSemiTransparent}>
      <Spinner />
    </StyledLoaderOverlay>
  )
}

export default LoaderOverlay
